import { styled } from '../../base';

export const StyledUserSettingsPage = styled('div')(({ theme }) => ({
    padding: theme.spacing(3),
    alignItems: 'center',
    marginBottom: theme.spacing(4),
}));
